module.exports = __webpack_public_path__ + "static/img/car_binding_edit.b4c8f05e.png";